const { remove } = require("lodash");

document.addEventListener('DOMContentLoaded', () => {
  let resizeCount = 0;
  const maxResizeCount = 20;
  const leafletImage = document.querySelector('img.leaflet');

  if (!leafletImage) {
    return;
  }

  const getBoundingBoxParam = () => {
    const boundingBoxParam = [];
    const dataBoundingBox = leafletImage.dataset.boundingBox;

    if (!dataBoundingBox) {
      return boundingBoxParam;
    }

    const boundingBox = dataBoundingBox.split('_');
    boundingBox.forEach(pointString => {
      const point = parseFloat(pointString);
      if (!isNaN(point) && point > 0) {
        boundingBoxParam.push(point);
      }
    });

    return boundingBoxParam;
  };

  const validateBoundingBoxParam = boundingBoxParam => {
    return boundingBoxParam.length === 4 &&
      boundingBoxParam[2] - boundingBoxParam[0] > 0 &&
      boundingBoxParam[3] - boundingBoxParam[1] > 0;
  };

  const setLeafletProductOverlay = boundingBoxParam => {
    // 共通処理を関数に分離
    const scale = getScaleFactor(leafletImage);
    const { centerX, centerY, radius } = getBoundingDimensions(boundingBoxParam, scale);

    const leafletProductOverlay = createOverlay(centerX, centerY, radius);
    removeFocusOnEvent(leafletProductOverlay);

    // 吹き出しを設定
    const speechBubble = createSpeechBubble(centerX, centerY, radius);
    leafletProductOverlay.appendChild(speechBubble);

    leafletImage.insertAdjacentElement('afterend', leafletProductOverlay);
  };

  const getScaleFactor = imageElement => {
    const originWidth = imageElement.dataset.originWidth;
    return originWidth ? imageElement.clientWidth / originWidth : 1.0;
  };

  const getBoundingDimensions = (boundingBoxParam, scale) => {
    const width = boundingBoxParam[2] - boundingBoxParam[0];
    const height = boundingBoxParam[3] - boundingBoxParam[1];
    const centerX = (boundingBoxParam[0] + width / 2.0) * scale;
    const centerY = (boundingBoxParam[1] + height / 2.0) * scale;
    const radiusCorrectionFactor = 1.2;
    const radius = width > height
      ? (width / 2.0) * scale * radiusCorrectionFactor
      : (height / 2.0) * scale * radiusCorrectionFactor;

    return { centerX, centerY, radius };
  };

  const createOverlay = (centerX, centerY, radius) => {
    const overlay = document.createElement('div');
    overlay.className = 'leaflet_product_overlay';
    overlay.style.maskImage = `radial-gradient(circle at ${centerX.toFixed()}px ${centerY.toFixed()}px, transparent ${radius.toFixed()}px, black ${radius.toFixed()}px)`;
    overlay.style.position = 'absolute';
    overlay.style.top = leafletImage.style.top;
    overlay.style.left = leafletImage.style.left;
    overlay.style.width = leafletImage.style.width;
    overlay.style.height = leafletImage.style.height;
    return overlay;
  };

  const removeFocusOnEvent = element => {
    const removeFocus = () => {
      resizeObserver.unobserve(leafletImage);
      element.style.transition = 'opacity 0.5s ease';
      element.style.opacity = 0;
      setTimeout(() => element.remove(), 500);
    };

    element.addEventListener('click', removeFocus);
    element.addEventListener('scroll', removeFocus);
    document.querySelectorAll('.other_leaflets_navigation_button').forEach(button => {
      button.addEventListener('click', removeFocus);
    });
  };

  const createSpeechBubble = (centerX, centerY, radius) => {
    const speechBubble = document.createElement('div');
    speechBubble.className = 'tail';
    speechBubble.textContent = '商品はこちら';
    const offset = 6;
    const speechBubbleWidth = 100;
    const speechBubbleHeight = 37;
    let left, top;

    if (centerX < speechBubbleWidth / 2) {
      left = (centerX + radius + offset).toFixed();
      top = (centerY - speechBubbleHeight / 2).toFixed();
      speechBubble.classList.add('tail_left');
    } else if (centerX + speechBubbleWidth / 2 > leafletImage.clientWidth) {
      left = (centerX - radius - speechBubbleWidth - offset).toFixed();
      top = (centerY - speechBubbleHeight / 2).toFixed();
      speechBubble.classList.add('tail_right');
    } else {
      left = (centerX - speechBubbleWidth / 2).toFixed();
      if (centerY > leafletImage.clientHeight / 2) {
        top = (centerY - radius - speechBubbleHeight - offset).toFixed();
        speechBubble.classList.add('tail_bottom');
      } else {
        top = (centerY + radius + offset).toFixed();
        speechBubble.classList.add('tail_top');
      }
    }

    speechBubble.style.position = 'absolute';  // 設置場所を正しく設定するために追加
    speechBubble.style.top = `${top}px`;
    speechBubble.style.left = `${left}px`;

    return speechBubble;
  };

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const overlay = document.querySelector('.leaflet_product_overlay');

      if (resizeCount >= maxResizeCount) {
        if (overlay) {
          overlay.remove();
        }

        resizeObserver.unobserve(leafletImage);
      } else {
        const boundingBoxParam = getBoundingBoxParam();

        if (!validateBoundingBoxParam(boundingBoxParam)) {
          return false;
        }


        if (overlay) {
          overlay.remove();
        }
        setLeafletProductOverlay(boundingBoxParam);

        resizeCount++;
      }
    }
  });

  resizeObserver.observe(leafletImage);
});
